import { observer } from 'mobx-react-lite';
import { DateTime } from 'luxon';
import React from 'react';
import { Await } from '../../../components/Await';
import { Footer as RawFooter } from '../../../components/landingPage/Footer';
import { SanityObject, useSanity, MenuItem } from '../../../lib/landingPage';
import { renderIcons, renderFooterMenuItems } from './formatters';
import { SocialMedia } from './types';

export type FooterProps = {
    children: SanityObject<MenuItem>[];
    socialMediaLinks: SanityObject<SocialMedia>[];
};

type FooterResolvedProps = {
    footer: SanityObject<FooterProps>;
    hideMenu: boolean;
};

const FooterResolved = observer((p: FooterResolvedProps) => {
    return (
        <RawFooter
            year={DateTime.now().year.toString()}
            links={renderFooterMenuItems(p.footer.children)}
            socialMediaLinks={renderIcons(p.footer.socialMediaLinks)}
            hideMenu={p.hideMenu}
        />
    );
});

export const Footer = observer(({ hideMenu }: { hideMenu: boolean }) => {
    const store = useSanity();
    return (
        <Await
            views={{ footer: store.asyncFooter }}
            resolved={FooterResolved}
            extra={{ hideMenu }}
        />
    );
});
